import React from 'react';
import PropTypes from 'prop-types';

import {Box, Chip, Stack, Typography} from 'views/components';

import {Translate, translate} from 'views/module';

const CareApproachSection = (props) => {
  const {questions} = props;

  const personalitySummary = questions.personalitySummary;
  const personalityDescriptorChips = personalitySummary.descriptorChips;

  const personalityDimsTranslationMap = {
    decisionStyle: translate('caregiverDetail.CareApproach.PersonalityDimensions.DecisionStyle'),
    careDrive: translate('caregiverDetail.CareApproach.PersonalityDimensions.CareDrive'),
    reliability: translate('caregiverDetail.CareApproach.PersonalityDimensions.Reliability'),
  };


  return (
    <Stack alignItems="flex-start" width="100%" spacing={{xs: 2, md: 3}} sx={{}}>
      <Stack spacing={1.5}>
        <Typography
          variant="body1"
          fontWeight="bold"
          sx={{
            color: '#686868',
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
            pb: 0.5,
          }}
        >
          <Translate expression='caregiverDetail.CareApproach.CareStyle'/>
        </Typography>
        <Stack
          direction="row"
          justifyContent="flex-start"
          gap={1}
          rowGap={1}
          flexWrap="wrap"
        >
          {
            personalityDescriptorChips.map((chipLabel, idx) => {
              return (
                <Chip
                  key={idx}
                  label={chipLabel}
                  sx={{
                    bgcolor: idx % 2 === 1 ? 'white' : '#F9F5F2',
                    borderRadius: 4,
                    border: 1,
                    borderColor: 'color.divider',
                    color: 'black',
                    fontSize: '0.75rem',
                    fontWeight: 500,
                    py: 1,
                    px: 2,
                  }}
                />
              );
            })
          }
        </Stack>
        <Box
          alignItems="center"
          sx={{
            bgcolor: '#F8F3EFCC',
            py: {xs: 1.5, md: 3},
            px: {xs: 2, md: 3.5},
            borderRadius: 2,
          }}
        >
          <Typography variant="body2" fontSize="14px" color="text.primary">
            {personalitySummary.overallSummary}
          </Typography>
        </Box>
      </Stack>
      <Stack spacing={1.5}>
        <Typography
          variant="body1"
          fontWeight="bold"
          sx={{
            color: '#686868',
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
          }}
        >
          <Translate expression='caregiverDetail.CareApproach.HowTheyHandleSituations'/>
        </Typography>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {xs: '1fr', md: '1fr 1fr 1fr'},
            gap: 2,
            width: '100%',
          }}
        >
          {
            Object.entries(personalityDimsTranslationMap).map(([dimensionKey, scenarioLabel]) => {
              const responseLabel = personalitySummary?.[dimensionKey];

              if (!responseLabel) {
                return null;
              }

              return (
                <Stack
                  key={dimensionKey}
                  spacing={2}
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    bgcolor: 'color.white',
                    width: '100%',
                    boxSizing: 'border-box',
                    border: '1px solid',
                    borderColor: 'color.divider',
                    borderLeft: '3px solid',
                    borderLeftColor: 'primary.main',
                    m: 0,
                  }}
                >
                  <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
                    {scenarioLabel}
                  </Typography>

                  <Typography variant="body2" sx={{color: '#686868', lineHeight: '24px'}}>
                    {`"${responseLabel}"`}
                  </Typography>
                </Stack>
              );
            })
          }
        </Box>
      </Stack>
    </Stack>
  );
};

CareApproachSection.propTypes = {
  questions: PropTypes.shape({
    personalitySummary: PropTypes.shape({
      overallSummary: PropTypes.string.isRequired,
      descriptorChips: PropTypes.arrayOf(PropTypes.string).isRequired,
      decisionStyle: PropTypes.string.isRequired,
      careDrive: PropTypes.string.isRequired,
      reliability: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default React.memo(CareApproachSection);
